import {useEffect, useMemo, useState} from 'react'
import {
  generatedPartnerSchema,
  legacyPartnerSchema,
  ycFounderSchema,
} from './schemas'
import {type ReferrerData} from './types'
import {devLog} from '../Analytics'

const REFERRER_DATA_KEY = 'referrerData'

export function useReferrerData() {
  const [referrerDataLocalStorage, setReferrerDataLocalStorage] = useState<
    object | null
  >(null)

  useEffect(() => {
    try {
      const referrerData = localStorage.getItem(REFERRER_DATA_KEY)
      if (referrerData) {
        setReferrerDataLocalStorage(JSON.parse(referrerData))
      }
    } catch {
      setReferrerDataLocalStorage(null)
    }
  }, [])

  const referrerData: ReferrerData | null = useMemo(() => {
    if (!referrerDataLocalStorage) return null
    /**
     * The way we store referrer data in localStorage is without the `type`.
     * We then parse the JSON and if it passes the validator then we assume it' that type.
     * See `deserializeReferrer` in `mercury-web`
     */
    try {
      return {
        ...generatedPartnerSchema.parse(referrerDataLocalStorage),
        type: 'generatedPartner',
      }
    } catch (err) {
      devLog(err)
    }
    try {
      return {
        ...ycFounderSchema.parse(referrerDataLocalStorage),
        type: 'ycFounder',
      }
    } catch (err) {
      devLog(err)
    }
    try {
      return {
        ...legacyPartnerSchema.parse(referrerDataLocalStorage),
        type: 'legacyPartner',
      }
    } catch (err) {
      devLog(err)
    }

    return null
  }, [referrerDataLocalStorage])

  return referrerData
}
